// @flow

import React from "react"
import ModuleIterator from "components/ModuleIterator"
import Layout from "../components/Layout"
import { Helmet } from "react-helmet"
import type { Meta, Module } from "types/"
import ModalCookies from "./ModalCookies"

type Props = {
  meta: Meta,
  structure: Array<Module>,
  language: string,
  route: string,
  literals: {},
}

const Page = ({ meta, structure, literals, language }: Props) => {
  const { title, description, keywords, canonical, author, hidden }: Meta = meta
  return (
    <>
      <Helmet
        title="es"
        defer={false}
        htmlAttributes={{ lang: language, description, keywords }}
        link={[
          { rel: "icon", type: "image/x-icon", href: "/favicon-2.ico" },
          { rel: "icon", type: "image/svg+xml", href: "/favicon-2.svg" },
          {
            rel: "icon",
            type: "image/png",
            sizes: "96x96",
            href: "/favicon-96x96-2.png",
          },
          { rel: "apple-touch-icon", href: "/apple-touch-icon-2.png" },
          {
            rel: "icon",
            type: "image/png",
            sizes: "192x192",
            href: "/android-chrome-192x192.png",
          },
          {
            rel: "icon",
            type: "image/png",
            sizes: "512x512",
            href: "/android-chrome-512x512.png",
          },
          { rel: "manifest", href: "/site.webmanifest" },
        ]}
      >
        <meta name="apple-mobile-web-app-title" content="A2C" />
        <meta name="apple-mobile-web-app-title" content="A2C" />
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta
          name="author"
          content={author || "Dallonses, hello@dallones.com"}
        />
        <meta name="canonical" content={canonical} />
        {hidden && <meta name="robots" content="noindex, nofollow" />}
        {/* This will allow to ask Google to recrawl the site */}
        <meta
          name="google-site-verification"
          content="yuCx-nblxBXy3CumheEwlfe9cw4Dzt30nvHwbnaQ5sI"
        />
      </Helmet>
      <Layout>
        <ModuleIterator modules={structure} />
      </Layout>
      <ModalCookies
        key="cookies"
        titleCookies={literals.cookies.titleCookies}
        text={literals.cookies.text}
        textCookiesPolicy={literals.cookies.textCookiesPolicy}
        text2CookiesPolicy={literals.cookies.text2CookiesPolicy}
        ctaLabelCookiesPolicy={literals.cookies.ctaLabelCookiesPolicy}
        cookiesPolicyURL={literals.cookies.cookiesPolicyURL}
        ctaLabel={literals.cookies.ctaLabel}
      />
    </>
  )
}

export default Page
